import { render, staticRenderFns } from "./WizardPickupType.vue?vue&type=template&id=6f14a445&scoped=true"
import script from "./WizardPickupType.vue?vue&type=script&setup=true&lang=js"
export * from "./WizardPickupType.vue?vue&type=script&setup=true&lang=js"
import style0 from "./WizardPickupType.vue?vue&type=style&index=0&id=6f14a445&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_1c848d52c9dbe574bb8312e4e1e1d32e/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f14a445",
  null
  
)

export default component.exports